<app-tablepage-base [loading]="loading">

  <!-- 1. LA TABELLA (Dichiarata semplicemente con scrollHeight="100%") -->
  <p-table [value]="departments"
           [paginator]="true" [rows]="25"
           [scrollable]="true" scrollHeight="flex"
           [globalFilterFields]="['departmentId', 'name']"
           stripedRows
           #dt
           class="flex h-full min-h-0 flex-col">
    <ng-template #caption>
      <div class="flex items-center justify-between">
        <span class="text-xl font-bold">{{ 'titles.listDepartments' | translate }}</span>
        <div class=" inline-flex gap-2">
          <div class="flex">
            <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="{{ 'search' | translate }}..." />
          </div>
          <p-button variant="outlined" icon="pi pi-sitemap" [label]="'newDept' | translate" (click)="onShowDialog(newDepartment)" />
        </div>
      </div>
    </ng-template>
    <ng-template #header>
      <tr>
        <th style="width:10%">ID</th>
        <th style="width:20%">{{ 'organization' | translate }}</th>
        <th>{{ 'name' | translate }}</th>
        <th style="width:10%"></th>
      </tr>
    </ng-template>
    <ng-template #body let-department>
      <tr [pSelectableRow]="department">
        <td>{{ department.departmentId }}</td>
        <td>{{ department.organization }}</td>
        <td>{{ department.name }}</td>
        <td>
          <p-button icon="pi pi-file-edit" (click)="onShowDialog(department)" />
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- 2. DIALOG (Posizionata fuori dal flusso, non rompe il layout) -->
  <app-department-dialog [isNew]="isNew"
                         [messageService]="messageService"
                         [(visible)]="showDialog"
                         [department]="selectedDepartment"
                         (saved)="onDepartmentSaved($event)">
  </app-department-dialog>
</app-tablepage-base>
